import { CloseOutlined, UploadOutlined } from '@ant-design/icons';
import inquiryService from '@root/modules/Warehouse/Inquiry/service/inquiry';
import { IComment, IDocument } from '@root/modules/Warehouse/interface';
import { Button, Form, Input, message, Spin, Upload, UploadProps } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import {
  InternalUploadFile,
  RcFile,
  UploadFile
} from 'antd/lib/upload/interface';
import { values } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
interface Props {
  inquiryId: number;
  comment: IComment | any;
  onSubmitted: () => void;
  setLoadingCmt?: boolean;
}

interface inquiryId {
  id: string;
}
const CmtEdit: React.FC<Props> = ({ comment, onSubmitted, setLoadingCmt }) => {
  /*--------------edit cmt--------------*/

  const inquiryId: inquiryId = useParams();
  const [fileList, setFileList] = useState<UploadFile[] | any>([]);
  const [map, setMap] = useState(comment.documents);
  const [loading, setLoading] = useState(false);

  const validateNumberOfFile = (fileList: number, map: number) => {
    return fileList + map;
  };

  const isMax = validateNumberOfFile(fileList.length, map.length);

  const handleGet = async (values: any) => {
    try {
      if (isMax > 5) {
        message.error('Sum of all files must be less than 6');
      } else {
        setLoading(true);
        const fileIdArr = map.map((item: IDocument) => item.id);
        if (fileList.length > 0) {
          const formData = new FormData();
          for (let i = 0; i < fileList.length; i++) {
            formData.append('files', fileList[i].originFileObj || fileList[i]);
          }
          const uploadData = await inquiryService.postUploadImg(formData);
          for (let i = 0; i < uploadData.data.length; i++) {
            setFileList([...fileList]);
            fileIdArr.push(uploadData.data[i].id);
          }
        }
        const body = {
          owner: comment.owner,
          comment: values.comment,
          quotationId: inquiryId.id,
          documents: fileIdArr
        };

        const edit = await inquiryService.putCommentWare(
          inquiryId.id,
          comment.id,
          body
        );

        message.success('Edit success!');
        onSubmitted();
      }
    } catch (error) {
      message.error("Can't edit comment");
    }
    setLoading(false);
  };

  /*---------------delete image---------*/

  const removeItemIndex = (index: number) => {
    setFileList([
      ...fileList.filter(
        (selected: any) => fileList.indexOf(selected) !== index
      )
    ]);
  };

  const removeItem = (id: number) => {
    setMap([...map.filter((element: IDocument) => element.id !== id)]);
  };

  const validateFileType = (
    { type }: UploadFile,
    allowedTypes: string[] = ['image/jpeg', 'image/png']
  ) => {
    return allowedTypes.includes(type!);
  };

  const props: UploadProps = {
    onChange({ fileList: newFileList }) {
      // if (isMax >= 5) {
      //   message.error(`Over 5 files`);

      //   return;
      // }
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      const isAllowedType = validateFileType(file);
      if (!isAllowedType) {
        message.error(`${file.name} is not JPEG file`);
        return false;
      }
      // if (isMax >= 5) {
      //   message.error(`Over 5 files`);
      //   return false;
      // }
      // setFileList((prev: any) => {
      //   if (prev.length < 5) {
      //     return [...prev, file];
      //   }
      //   return prev;
      // });
      // setFileList([...fileList, file]);
      // return false;
    }
  };
  return (
    <div key={comment.id}>
      <Spin spinning={loading}>
        <Form
          onFinish={handleGet}
          layout="vertical"
          style={{ width: '100%', display: 'flex', gap: '10px' }}
          initialValues={{
            ['comment']: comment.comment
          }}
        >
          <div className="attachUp" style={{ marginBottom: '10px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <div style={{ marginBottom: '10px' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <p style={{ marginBottom: '0px', whiteSpace: 'nowrap' }}>
                    Warehouse edit
                  </p>

                  <Form.Item rules={[{ required: true }]}>
                    <Upload
                      {...props}
                      multiple
                      fileList={fileList}
                      accept=".png, .jpg, .jpeg"
                      maxCount={5}
                      showUploadList={false}
                    >
                      <Button> Upload</Button>
                    </Upload>
                  </Form.Item>
                </div>

                <div
                  className="scrollImg"
                  style={{
                    height: '90px',
                    overflowY: 'scroll',
                    overflowX: 'scroll',
                    width: '320px',
                    marginTop: '10px'
                  }}
                >
                  <ul style={{ listStyleType: 'none', padding: '0' }}>
                    {fileList.map((item: any, index: number) => (
                      <li
                        key={index}
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        {item.name}
                        <span
                          style={{ cursor: 'pointer', display: 'flex' }}
                          onClick={() => removeItemIndex(index)}
                        >
                          <CloseOutlined />
                        </span>
                      </li>
                    ))}
                    <li>
                      {map.map((item: IDocument, index: number) => (
                        <p
                          key={index}
                          style={{
                            marginBottom: '0px',
                            color: '#A6A6A6',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          {item.fileName}

                          <span
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                            onClick={() => removeItem(item.id)}
                          >
                            <CloseOutlined />
                          </span>
                        </p>
                      ))}
                    </li>
                  </ul>
                </div>
              </div>
            </div>{' '}
          </div>
          {map.length > 5 ? <p>sdsds</p> : null}
          <div className="commentCard" style={{ marginBottom: '10px' }}>
            <div
              className="wrapTitle"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <p>{comment.owner}</p>
            </div>
            <Form.Item
              name="comment"
              rules={[
                {
                  required: true,
                  message: 'Comment can not be empty'
                },
                {
                  max: 150,
                  message: 'Character must be less than 150!'
                }
              ]}
            >
              <Input.TextArea
                defaultValue={comment.comment}
                style={{ resize: 'none' }}
                cols={4}
              />
            </Form.Item>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                marginTop: '20px'
              }}
            >
              <Button
                htmlType="submit"
                type="primary"
                style={{
                  background: '#3c3d5f',
                  border: 'none',
                  color: 'white',
                  borderRadius: '8px'
                }}
              >
                Send
              </Button>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default CmtEdit;
